let state = {
  filters: null,
  filtersData: null,
};

const getters = {
  GET_FILTERS(state) {
    return state.filters;
  },
  GET_FILTERS_DATA(state) {
    return state.filtersData;
  },
};

const mutations = {
  SET_FILTERS(state, data) {
    state.filters = data.filters;
    state.filtersData = data.filtersData;
  },
  SET_FILTERS_DATA(state, data) {
    state.filtersData = data;
  },
  SET_FILTERS_DATA_ITEM(state, data) {
    state.filtersData[data.name][data.value] = data.status;
  },
  RESET(state) {
    state.filters = null;
    state.filtersData = null;
  },
};

const actions = {
  setFilters({ commit }, data) {
    commit('SET_FILTERS', data);
  },
  setActiveFilters({ commit }, data) {
    commit('SET_ACTIVE_FILTERS', data);
  },
  setFiltersData({ commit }, data) {
    commit('SET_FILTERS_DATA', data);
  },
  setFiltersDataItem({ commit }, data) {
    commit('SET_FILTERS_DATA_ITEM', data);
  },
  reset({ commit }) {
    commit('RESET');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
